import React from "react";
import { Link } from "react-router-dom";
import { LogoIcon } from "./Logo";
import { useAuth } from "../context/AuthContext";
import { CONTACT_EMAIL } from "../constants/disclaimer";

export function Footer() {
  const { user } = useAuth();
  return (
    <footer id="about" className="mt-24 border-t border-border/60 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2">
            <LogoIcon size={30} />
            <span className="font-heading font-black text-xl lowercase text-ink">flavoria</span>
          </div>
          <p className="mt-4 text-ink-soft max-w-sm leading-relaxed">
            Flavoria doesn't drown you in hundreds of results. We surface the 3 recipes worth your
            time — earned through ratings, trust and quality, never sold.
          </p>
          <p className="mt-4 text-xs font-bold tracking-widest uppercase text-ink-soft/70">
            Stop scrolling. Start cooking.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-black text-ink mb-4">Explore</h4>
          <ul className="space-y-2 text-ink-soft font-semibold">
            <li><Link to="/" className="hover:text-coral">Discover</Link></li>
            <li><Link to="/categories" className="hover:text-coral">Categories</Link></li>
            <li><Link to="/plan-meal" className="hover:text-coral">Plan your Meal</Link></li>
            <li><Link to="/disclaimer" className="hover:text-coral" data-testid="footer-disclaimer-link">Disclaimer</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-black text-ink mb-4">Chefs</h4>
          <ul className="space-y-2 text-ink-soft font-semibold">
            <li><Link to="/chefs" className="hover:text-coral" data-testid="footer-chefs-link">Discover chefs</Link></li>
            <li><Link to="/kitchen" className="hover:text-coral" data-testid="footer-become-chef-link">Become a Chef</Link></li>
            <li><Link to="/kitchen" className="hover:text-coral">My Kitchen</Link></li>
            {!user && <li><Link to="/login" className="hover:text-coral">Log in</Link></li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 text-center text-sm text-ink-soft space-y-2">
        <p>© {new Date().getFullYear()} Flavoria · The 3 recipes worth your time.</p>
        <p className="flex items-center justify-center gap-2 flex-wrap">
          <Link to="/disclaimer" data-testid="footer-disclaimer" className="font-semibold text-coral hover:underline">Disclaimer</Link>
          <span aria-hidden>·</span>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact" className="font-semibold hover:text-coral">{CONTACT_EMAIL}</a>
        </p>
      </div>
    </footer>
  );
}
